import { CLINICAL_ROUTES } from '@clinical/clinical-routes.module';
import { MEDICINES_ROUTES } from '@clinical/medicines/medicines-routes.module';
import { ROOT_ROUTES } from '../../../app-routing.module';
import { PAPERWORK_RECIPES_DEFINITION } from '@clinical/medicines/constants/paperwork-recipes.const';

/**
 * Mapeo de grupos de recetas a sus secciones de visualización.
 *
 * @description
 * Define la correspondencia entre los grupos de recetas médicas y sus
 * etiquetas de sección para mostrar en la interfaz de usuario.
 *
 * @deprecated Se recomienda usar RECIPES_V2 que incluye soporte para recetas de diabetes
 */
export const RECIPES = {
  [PAPERWORK_RECIPES_DEFINITION.receta.group]: {
    section: 'Receta Médica',
  },
  [PAPERWORK_RECIPES_DEFINITION.magistral.group]: {
    section: 'Receta Magistral',
  },
};

/**
 * Mapeo actualizado de sufijos de recetas a sus secciones de visualización (versión 2).
 *
 * @description
 * Define la correspondencia entre los sufijos identificadores de cada tipo de receta
 * y sus etiquetas de sección para la interfaz de usuario. Esta versión incluye soporte
 * completo para recetas de diabetes además de las recetas médicas generales y magistrales.
 *
 * @property {Object} RMG - Receta Médica General
 * @property {Object} RMD - Receta Médica de Diabetes
 * @property {Object} RMM - Receta Magistral (preparaciones farmacéuticas)
 */
export const RECIPES_V2 = {
  [PAPERWORK_RECIPES_DEFINITION.receta.suffix]: {
    section: 'Receta Médica',
  },
  [PAPERWORK_RECIPES_DEFINITION.diabetes.suffix]: {
    section: 'Receta Diabetes',
  },
  [PAPERWORK_RECIPES_DEFINITION.magistral.suffix]: {
    section: 'Receta Magistral',
  },
};

/**
 * Ruta completa para acceder al historial de recetas del profesional.
 *
 * @description
 * Constante que construye la URL completa para navegar al historial de recetas
 * emitidas por el profesional de salud actualmente autenticado en el sistema.
 *
 * @type {string}
 *
 * @example
 * // Formato: /clinical/medicines/history-professional-recipes
 */
export const HISTORY_PROFESSIONAL_ROUTE =
  `/${ROOT_ROUTES.clinical}/${CLINICAL_ROUTES.medicines}/${MEDICINES_ROUTES.historyProfessionalRecipes}`;
